import { useProxyState } from "./useProxyState.js";
import { useSubscribe } from "./useSubscribe.js";
/**
 * A hook to subscribe to a GraphQL subscription and return the current state.
 *
 * @example
 * ```tsx
 * const { data, isLoading, error } = useSubscription(MySubscriptionDocument, {
 *   variables: { id: '123' },
 * });
 *
 * if (isLoading) return <Loading />;
 * if (error) return <Error error={error} />;
 * return <div>{data?.myField}</div>;
 * ```
 */
export const useSubscription = (document, ...[options]) => {
    const state = useProxyState({ data: null, isLoading: true, error: null });
    // biome-ignore lint/suspicious/noExplicitAny: CBA to find the correct type
    useSubscribe({
        document,
        ...options,
        replay: true,
        next: (data) => {
            state.data = data.data;
            state.isLoading = false;
        },
        error: (error) => {
            state.error = error instanceof Error ? error : new Error(String(error));
            state.isLoading = false;
        },
        complete: () => {
            state.isLoading = false;
        },
    });
    return state;
};
//# sourceMappingURL=useSubscription.js.map